import { Box } from "@chakra-ui/react";
import {
  ClickEventType,
  ColorIcon,
  colors,
  customEvent,
  Dropdown,
  FUNERAL_SIGUNGU,
  NextLink,
  VStack,
} from "goi_common";
import { useRouter } from "next/router";
import { useState } from "react";

export default function SigunguSelector({
  sido,
  regionType = "장례식장",
  sidoName,
  sigunguName,
  eventPath = "parlor_region",
}: {
  sido: string;
  regionType?: "장례식장" | "납골당" | "수목장" | "";
  sidoName: string;
  sigunguName?: string;
  eventPath?: string;
}) {
  const sigungus = Array.from(FUNERAL_SIGUNGU.get(Number(sido))!).map((sigungu) => ({
    key: sigungu[1],
    value: String(sigungu[0]),
  }));

  const [sigungu] = useState<string | undefined>(sigungus[0].value);

  const router = useRouter();

  const regionPath = (regionType: string) => {
    if (regionType === "장례식장") {
      return `/parlors/region`;
    } else if (regionType === "납골당") {
      return `/facilities/region/charnel`;
    } else if (regionType === "수목장") {
      return `/facilities/region/woodland`;
    }
  };

  return (
    <>
      {sigunguName ? (
        <NextLink href={`${regionPath(regionType)}/${sidoName}/`}>
          <Box
            paddingTop={"4px"}
            paddingBottom="12px"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            className="body_14_m gray800"
            textAlign="right"
            style={{ cursor: "pointer" }}
            gap="4px"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: eventPath as ClickEventType["path"],
                  trigger_and_target: "select_sido-uv_region_sido",
                },
              });
            }}
          >
            <div>
              {sidoName} {regionType} <br />
              전체보기
            </div>
            <ColorIcon name="arrow_right_small" color={colors.gray600} width="16px" height="16px" />
          </Box>
        </NextLink>
      ) : (
        <VStack>
          <VStack justifyContent="space-between" alignItems="flex-end">
            <Box className="subtitle_14_sb gray800">지역별로 확인하기</Box>
            <Dropdown
              name="지역"
              forceZIndex={1}
              value={sigungu}
              values={sigungus}
              onChange={(v) => {
                customEvent({
                  newGtm: {
                    path: eventPath as ClickEventType["path"],
                    trigger_and_target: "select_sigungu-select",
                    text: v,
                  },
                });

                const selectSigungu = sigungus.find((s) => s.value === v)?.key;
                router.push(`${regionPath(regionType)}/${sidoName}-${selectSigungu}/`);
              }}
            />
          </VStack>
        </VStack>
      )}
    </>
  );
}
